import React from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";

const Notice = () => {
  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin: '2%',
        borderRadius: '10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faBell} className="me-2" />
            Agniveer Notices
          </h3>
        </Container>
      </div>

      <Container className="py-5">
        <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faBell} className="me-2" />
              Latest Notices
            </h4>
          </div>
          <CardBody className="p-4">
            <div className="text-center py-5">
              <FontAwesomeIcon 
                icon={faBell} 
                style={{ 
                  fontSize: '4rem', 
                  color: '#dee2e6',
                  marginBottom: '20px'
                }} 
              />
              <h5 style={{ color: '#6c757d', fontWeight: '600' }}>No notices available at this time</h5>
              <p style={{ color: '#6c757d', marginTop: '10px' }}>
                Please check back later for updates on Agniveer notices and announcements.
              </p>
            </div>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default Notice